import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";

export const getAllOrganizationDocuments = (businessIdentifier) => {
  return dispatch => {
    dispatch({ type: "GET_ORGANIZATION_DOCUMENTS_LOADING" });
    api
      .organizationDocumentsGetAll(businessIdentifier)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchOrganizationDocumentsAlertTitle",
          "Virhe yrityksen dokumenttien noutamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_ORGANIZATION_DOCUMENTS_SUCCEEDED",
  payload: { organizationDocuments: data },
});

const operationFail = () => ({
  type: "GET_ORGANIZATION_DOCUMENTS_FAIL"
});
